<svg
  class="icon"
  [attr.width]="width"
  [attr.height]="height"
  [attr.viewBox]="viewBox"
  fill="currentColor"
>
  @for (path of iconData?.svgPaths; track path) {
    <path [attr.d]="path.value" [attr.fill]="path.fill"></path>
  }
  @for (rect of iconData?.svgRects; track rect) {
    <rect
      [attr.x]="rect.x"
      [attr.y]="rect.y"
      [attr.width]="rect.width"
      [attr.height]="rect.height"
      [attr.fill]="rect.fill"
    />
  }
</svg>
